import { createContext, useContext } from 'react';
export const MediaQueryContext = createContext(undefined);
export function useMediaQuery() {
    const context = useContext(MediaQueryContext);
    if (context === undefined) {
        throw new Error('useMediaQueryContext must be used within a MediaQueryProvider');
    }
    return context;
}
//# sourceMappingURL=MediaQueryContext.js.map